import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ERoleAdminString } from 'src/app/shared/data/role.enum';
import { ModalConfirmacaoService } from 'src/app/shared/services/modal-confirmacao.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import { ICadastroCentroCusto } from '../../models/centrocusto';
import { CentroCustosService } from '../../services/centro-custos.service';

@Component({
  selector: 'app-list-centro-custos',
  templateUrl: './list-centro-custos.component.html',
  styleUrls: ['./list-centro-custos.component.scss']
})
export class ListCentroCustosComponent {
  ERoleAdminString = ERoleAdminString;
  @Output() mudouPagina = new EventEmitter<number>();
  @Output() mudouTamanhoPagina = new EventEmitter<number>();
  @Output() recarregarListagem = new EventEmitter();
  @Input() centros: ICadastroCentroCusto[] = [];
  @Input() dadosPaginacao: {
    paginaSelecionada: number;
    tamanhoPagina: number;
    totalPaginas: number;
    itensTotal: number;
  } = {
    paginaSelecionada: 0,
    tamanhoPagina: 10,
    totalPaginas: 0,
    itensTotal: 0
  };

  constructor(
    private readonly centroCustoService: CentroCustosService,
    private readonly modalConfirmacao: ModalConfirmacaoService,
    private readonly toastService: ToastService
  ) {}

  public toogleCentroCustoStatus(centrosID: string, status: boolean): void {
    const textoStatus = status ? 'desativar' : 'ativar';

    this.modalConfirmacao
      .abrirModalConfirmacao({
        mensagem: `Tem certeza que deseja ${textoStatus} o centro de custo?`
      })
      .subscribe((resposta) => {
        if (!resposta) return;

        if (status) {
          this.centroCustoService.desativarCentrosCusto(centrosID).subscribe((resposta) => {
            if (resposta.messages && resposta.messages.length > 0) {
              this.toastService.toast(resposta.messages);
            }

            if (resposta.isSucceed) {
              this.recarregarListagem.emit();
            }
          });
        } else {
          this.centroCustoService.ativarCentrosCusto(centrosID).subscribe((resposta) => {
            if (resposta.messages && resposta.messages.length > 0) {
              this.toastService.toast(resposta.messages);
            }

            if (resposta.isSucceed) {
              this.recarregarListagem.emit();
            }
          });
        }
      });
  }
}
